module.exports = __webpack_public_path__ + "img/cliente-icon.d9fdd344.png";